import React from 'react';

import Button from '@elements/Button';
import ArrowRightSvg from '@svg/icons/arrow-right.svg';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';

import './style.css';

type CardPanelProps = {
  childClassName?: string,
  titleText: string,
  image: {
    title: string,
    gatsbyImageData: IGatsbyImageData,
  },
  icon: {
    title: string,
    file: {
      url: string,
    },
  },
  ctaLink: {
    slug: string,
  },
};

const CardPanel = ({
  image: preImage,
  titleText,
  icon,
  childClassName = '',
  ctaLink,
}: CardPanelProps): JSX.Element => {
  const image = getImage(preImage.gatsbyImageData);

  return (
    <div className={`card-panel__container ${childClassName}`}>
      <Button
        childClassName="card-panel__cta-button"
        href={`/${ctaLink.slug}/`}
      >
        { 
          icon.file && <img alt={icon.title} src={icon.file.url} /> 
        }
        <span>
          <h2>{titleText}</h2>
          <ArrowRightSvg />
        </span>
      </Button>
      {
        image && <GatsbyImage alt={preImage.title} image={image} />
      }
    </div>
  );
};

export default CardPanel;
